import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MenuRatingDto} from "./dto/menu-rating.dto";
import {MatDialog} from "@angular/material/dialog";
import {UploadImageComponent} from "../upload-image/upload-image.component";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'shared-menu-rating',
  templateUrl: './menu-rating.component.html',
  styleUrl: './menu-rating.component.scss',
})
export class MenuRatingComponent implements OnInit {
  @Input() label: string;
  @Input() companyCode: string;
  @Input() placeholder: string;
  @Input() image?: string;
  @Input() config: MenuRatingDto;
  @Input() isOpenNotes: boolean;
  @Output() value = new EventEmitter<number>();
  @Output() otherValue = new EventEmitter<string>();
  @Output() images = new EventEmitter<string[]>()
  valueSet: number;
  otherValueSet: string;
  imagesUploaded: string[] = [];
  imageTmpEndpoint = environment.baseUrl + "/upload/image/tmp/";
  placeholderNotes: string
  @ViewChild('notesEl') notesEl: ElementRef;
  constructor(public dialog: MatDialog) {}

  ngOnInit(): void {
    if (this.config === undefined) {
      this.config = {
        isRequired: false,
        initialValue: 0,
        initialOtherValue: "",
        initialImages: [],
        withOtherValue: false,
        isRequiredOtherValue: false
      }
    }
    if (this.config.initialValue) {
      this.valueSet = this.config.initialValue
    }
    if (this.config.initialOtherValue) {
      this.otherValueSet = this.config.initialOtherValue
    }

    if (this.config.initialImages) {
      this.imagesUploaded = this.config.initialImages
    }

    this.placeholderNotes = this.placeholder
      ? this.placeholder.replace("{{menuName}}", this.label)
      : "Penilaian " + this.label
  }

  onOpenNotes(): void {
    if (this.config.withOtherValue) {
      this.isOpenNotes = !this.isOpenNotes;
    }
  }

  onNotesChange(value: string): void {
    this.otherValue.emit(value)
  }

  onRatingSet(rating: number): void {
    this.value.emit(rating)
    if (this.config.withOtherValue){
      this.isOpenNotes = true;
      setTimeout(()=>{ // this will make the execution after the above boolean has changed
        this.notesEl.nativeElement.focus();
      },0);
    }
  }

  onBlur() {
    setTimeout(() => {
      this.onOpenNotes()
    }, 300)
  }

  openUploadDialog(filename: string, action: string): void {
    const dialogRef = this.dialog.open(UploadImageComponent, {
      panelClass: "border-radius-dialog",
      disableClose: true,
      autoFocus: false,
      data: {
        companyCode: this.companyCode,
        action: action,
        imagesUploaded: this.imagesUploaded,
        filename: filename
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.imagesUploaded = result.imagesPath;
      this.images.emit(this.imagesUploaded)
    });
  }

  onClickImage(filename: string) {
    this.openUploadDialog(filename, "update")
  }
}
